import WideoDef, { WideoDefVersion, Class, TransitionType, MaskType, Tween, ShapeType } from '../../core/model/WideoDef';
import { resourcesBaseUrl } from '../../../editor/core/EditorConstants';

export const DEFAULT_WIDEO_DEF: WideoDef = {
  "version": WideoDefVersion.V57,
  "id": "19822261509736344525",
  "timeStamp": 0,
  "class": Class.Wideo,
  "width": 1920,
  "height": 1080,
  "presentationMode": false,
  "scenes": [
    {
      "id": "scene-1",
      "class": Class.Scene,
      "version": WideoDefVersion.V57,
      "width": 1920,
      "height": 1080,
      "hidden": false,
      "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
      "attributes": {
        "x": 960,
        "y": 540,
        "scaleX": 1,
        "scaleY": 1,
        "rotation": 0,
        "alpha": 1
      },
      "components": [
        {
          "id": "back-1",
          "class": Class.BackgroundComponent,
          "color": "0x000000",
          "keepRatio": false,
          "src": null,
        },
        {
          "class": Class.TransitionComponent,
          "type": TransitionType.Outro,
          "tween": Tween.SlideLeft,
          "length": 500
        }
      ],
      "objects": [
        {
          "id": "text-text1",
          "class": Class.TextObject,
          "startTime": 0,
          "endTime": 5000,
          "hidden": false,
          "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "x": -280,
            "y": -170,
            "rotation": 0,
            "scaleX": 1,
            "scaleY": 1,
            "alpha": 1
          },
          "components": [
            {
              "class": Class.MaskComponent,
              "type": MaskType.Rectangle,
              "width": 1920,
              "height": 200
            },
            {
              "class": Class.AnimationComponent,
              "animation": {
                "keyFrames": [
                  {
                    "attributes": {
                      "x": 0,
                      "y": 0,
                      "rotation": 0,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 1000,
                    "id": "52443b3d-21da-401e-8b3f-2f5e7a13ee97"
                  },
                  {
                    "attributes": {
                      "x": 0,
                      "y": 0,
                      "rotation": 3.14,
                      "scaleX": 0,
                      "scaleY": 0,
                      "alpha": 0
                    },
                    "time": 2000,
                    "id": "052443b3d-21da-401e-8b3f-2f5e7a13ee97"

                  },
                  {
                    "attributes": {
                      "x": 0,
                      "y": 0,
                      "rotation": 0,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 3000,
                    "id": "152443b3d-21da-401e-8b3f-2f5e7a13ee97"
                  }
                ]
              }
            },
            {
              "class": Class.TransitionComponent,
              "type": TransitionType.Intro,
              "tween": Tween.PopIn,
              "length": 1000
            },
            {
              "id": 'text-text-1',
              "class": Class.TextComponent,
              "text": "An animated text, An animated text, An animated text, An animated text, other text",
              "width": 1920,
              "height": 36,
              "style": {
                "align": "left",
                "fontSize": 30,
                "fontWeight": "bold",
                "fontFamily": "OpenSans_Light",
                "fontStyle": "normal",
                "lineHeightFactor": 1.2,
                "fill": "#ff0099"
              }
            }
          ],
          "objects": []
        },
        {
          "id": "gif_test.gif",
          "class": Class.ImageObject,
          "startTime": 0,
          "endTime": 3000,
          "hidden": false,
          "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "x": 420,
            "y": -20,
            "scaleX": 1,
            "scaleY": 1,
            "rotation": 0.785,
            "alpha": 1
          },
          "components": [
            {
              "id": "gif_test.gif",
              "class": Class.ImageComponent,
              "src": resourcesBaseUrl + "/img/defaults/gif_test.png",
              "animated": false,
              "loop": true
            },
            {
              "class": Class.TransitionComponent,
              "type": TransitionType.Intro,
              "tween": Tween.ZoomIn,
              "length": 500
            },
            {
              "class": Class.TransitionComponent,
              "type": TransitionType.Outro,
              "tween": Tween.ZoomOut,
              "length": 500
            }
          ],
          "objects": []
        },
        {
          "id": "messizlatan.jpg",
          "class": Class.ImageObject,
          "startTime": 1000,
          "endTime": 5000,
          "hidden": false,
          "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "x": -230,
            "y": -20,
            "scaleX": 1,
            "scaleY": 1,
            "rotation": 0,
            "alpha": 1
          },
          "components": [
            {
              "id": "messizlatan.jpg",
              "class": Class.ImageComponent,
              "src": resourcesBaseUrl + "/img/defaults/messizlatan.jpg",
              "animated": false
            },
            {
              "class": Class.TransitionComponent,
              "type": TransitionType.Intro,
              "tween": Tween.PopIn,
              "length": 1000
            }
          ],
          "objects": []
        },
        {
          "id": "zlatan.jpg",
          "class": Class.ImageObject,
          "startTime": 0,
          "endTime": 5000,
          "hidden": false,
          "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "x": -96,
            "y": -54,
            "rotation": 0,
            "scaleX": 1,
            "scaleY": 1,
            "alpha": 1
          },
          "components": [
            {
              "id": "zlatan.jpg",
              "class": Class.ImageComponent,
              "src": resourcesBaseUrl + "/img/defaults/zlatan.jpg",
              "animated": false
            },
            {
              "class": Class.AnimationComponent,
              "animation": {
                "keyFrames": [
                  {
                    "attributes": {
                      "x": 0,
                      "y": 0,
                      "rotation": 0,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 0,
                    "id": "8f5216a1-fcc9-4243-95da-e6499656d65c"
                  },
                  {
                    "attributes": {
                      "x": 100,
                      "y": 0,
                      "rotation": 3.14,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 2000,
                    "id": "9f5216a1-fcc9-4243-95da-e6499656d65c"
                  },
                  {
                    "attributes": {
                      "x": 100,
                      "y": 100,
                      "rotation": 3.14,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 3000,
                    "id": "7f5216a1-fcc9-4243-95da-e6499656d65c"
                  },
                  {
                    "attributes": {
                      "x": 0,
                      "y": 100,
                      "rotation": 3.14,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 4000,
                    "id": "6f5216a1-fcc9-4243-95da-e6499656d65c"
                  },
                  {
                    "attributes": {
                      "x": 0,
                      "y": 0,
                      "rotation": 0,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 5000,
                    "id": "5f5216a1-fcc9-4243-95da-e6499656d65c"
                  }
                ]
              }
            }
          ],
          "objects": []
        },
        {
          "id": "cat.png",
          "class": Class.ImageObject,
          "startTime": 0,
          "endTime": 5000,
          "hidden": false,
          "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "x": -180,
            "y": 80,
            "rotation": 0,
            "scaleX": 1,
            "scaleY": 1,
            "alpha": 1
          },
          "components": [
            {
              "id": "cat.png",
              "class": Class.ImageComponent,
              "src": resourcesBaseUrl + "/img/defaults/cat.png",
              "animated": false
            },
            {
              "class": Class.AnimationComponent,
              "animation": {
                "keyFrames": [
                  {
                    "attributes": {
                      "x": 0,
                      "y": 0,
                      "rotation": 0,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 0,
                    "id": "9718db88-270e-4833-9fee-20c27fc78db7"
                  },
                  {
                    "attributes": {
                      "x": 500,
                      "y": 100,
                      "rotation": 0,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 2000,
                    "id": "8718db88-270e-4833-9fee-20c27fc78db7"
                  }
                ]
              }
            },
            {
              "class": Class.TransitionComponent,
              "type": TransitionType.Intro,
              "tween": Tween.SlideRight,
              "length": 500
            },
            {
              "class": Class.TransitionComponent,
              "type": TransitionType.Outro,
              "tween": Tween.SlideLeft,
              "length": 500
            }
          ],
          "objects": []
        }
      ],
      "startTime": 0,
      "endTime": 5000
    },
    {
      "id": "scene-2",
      "class": Class.Scene,
      "version": WideoDefVersion.V57,
      "width": 1920,
      "height": 1080,
      "hidden": false,
      "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
      "attributes": {
        "x": 960,
        "y": 540,
        "scaleX": 1,
        "scaleY": 1,
        "rotation": 0,
        "alpha": 1
      },
      "components": [
        {
          "id": "back-2",
          "class": Class.BackgroundComponent,
          "keepRatio": true,
          "src": resourcesBaseUrl + "/img/defaults/cat.png",
        },
        {
          "class": Class.TransitionComponent,
          "type": TransitionType.Intro,
          "tween": Tween.SlideLeft,
          "length": 500
        }
      ],
      "objects": [
        {
          "id": "text-2",
          "class": Class.TextObject,
          "startTime": 0,
          "endTime": 2000,
          "hidden": false,
          "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "x": 0,
            "y": 0,
            "rotation": 0,
            "scaleX": 1,
            "scaleY": 1,
            "alpha": 1
          },
          "components": [
            {
              "class": Class.MaskComponent,
              "type": MaskType.Rectangle,
              "width": 800,
              "height": 200
            },
            {
              "class": Class.AnimationComponent,
              "animation": {
                "keyFrames": [
                  {
                    "attributes": {
                      "rotation": 0,
                      "x": 0,
                      "y": 0,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 1000,
                    "id": "7215ba3f-2a77-4c06-bca3-cf71afdab97b"
                  },
                  {
                    "attributes": {
                      "rotation": 6.28,
                      "x": 0,
                      "y": 0,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 1500,
                    "id": "8215ba3f-2a77-4c06-bca3-cf71afdab97b"
                  }
                ]
              }
            },
            {
              "class": Class.TransitionComponent,
              "type": TransitionType.Intro,
              "tween": Tween.PopIn,
              "length": 1000
            },
            {
              "id": "text-text-2",
              "class": Class.TextComponent,
              "text": "A second animated text",
              "width": 800,
              "height": 36,
              "style": {
                "align": "left",
                "fontSize": 30,
                "fontFamily": "Helvetica_v2",
                "fontWeight": "bold",
                "fontStyle": "normal",
                "lineHeightFactor": 1.2,
                "fill": "#ffffff"
              }
            }
          ],
          "objects": []
        },
        {
          "id": "shape-1",
          "class": Class.ShapeObject,
          "startTime": 0,
          "endTime": 2000,
          "hidden": false,
          "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "rotation": 0,
            "x": 0,
            "y": 0,
            "scaleX": 3,
            "scaleY": 3,
            "alpha": 1
          },
          "components": [
            {
              "id": "shape-component-1",
              "class": Class.ShapeComponent,
              "shapeType": ShapeType.Star,
              "borderColor": '0x000000',
              "width": 100,
              "height": 100,
              "borderAlpha": 1,
              "fillAlpha": 1,
              "fillColor": '0xff0000',
              "borderThickness": 2,
            },
          ],
          "objects": []
        },

      ],
      "startTime": 5000,
      "endTime": 7000
    },
    {
      "id": "scene-3-placeholders",
      "class": Class.Scene,
      "version": WideoDefVersion.V57,
      "width": 1920,
      "height": 1080,
      "hidden": false,
      "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
      "attributes": {
        "x": 960,
        "y": 540,
        "scaleX": 1,
        "scaleY": 1,
        "rotation": 0,
        "alpha": 1
      },
      "components": [
        {
          "id": "back-3",
          "class": Class.BackgroundComponent,
          "color": "0xffffff",
        }
      ],
      "objects": [
        {
          "id": "scene-3-zlatan-placeholder",
          "class": Class.Placeholder,
          "startTime": 0,
          "endTime": 5000,
          "hidden": false,
          "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "x": -200,
            "y": 0,
            "scaleX": 0.5,
            "scaleY": 0.5,
            "rotation": 0,
            "alpha": 1
          },
          "components": [],
          "objects": [
            {
              "id": "scene-3-zlatan-placeholder-maskobject",
              "class": Class.MaskObject,
              "startTime": 0,
              "endTime": 5000,
              "hidden": false,
              "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
              "width": 700,
              "height": 400,
              "type": MaskType.RoundedRect,
              "targetId": "scene3-placeholder-zlatan-imageobject",
              "attributes": {
                "x": 0,
                "y": 0,
                "scaleX": 1,
                "scaleY": 1,
                "rotation": 0,
                "alpha": 1
              },
              "components": [
                {
                  "class": Class.TransitionComponent,
                  "type": TransitionType.Intro,
                  "tween": Tween.PopIn,
                  "length": 1000
                }
              ],
              "objects": []
            },
            {
              "id": "scene3-placeholder-zlatan-imageobject",
              "class": Class.ImageObject,
              "startTime": 0,
              "endTime": 5000,
              "hidden": false,
              "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
              "maskId": "scene-3-zlatan-placeholder-maskobject",
              "attributes": {
                "x": 0,
                "y": 0,
                "scaleX": 2,
                "scaleY": 2,
                "rotation": 0,
                "alpha": 1
              },
              "components": [
                {
                  "id": "scene3-placeholder-zlatan-imagecomponent",
                  "class": Class.ImageComponent,
                  "src": resourcesBaseUrl + "/img/defaults/zlatan.jpg",
                  "animated": false
                },
                {
                  "class": Class.AnimationComponent,
                  "animation": {
                    "keyFrames": [
                      {
                        "attributes": {
                          "rotation": 0,
                          "x": 0,
                          "y": 0,
                          "scaleX": 1,
                          "scaleY": 1,
                          "alpha": 1
                        },
                        "time": 0,
                        "id": "1a2aaffc-338b-48f7-a4d6-f2e0032904ae"
                      },
                      {
                        "attributes": {
                          "rotation": 0,
                          "x": 200,
                          "y": 200,
                          "scaleX": 2,
                          "scaleY": 2,
                          "alpha": 1
                        },
                        "time": 5000,
                        "id": "2a2aaffc-338b-48f7-a4d6-f2e0032904ae"
                      }
                    ]
                  }
                }
              ],
              "objects": []
            }
          ]
        }
      ],
      "startTime": 7000,
      "endTime": 12000
    },
    {
      "id": "scene-4-object-groups",
      "class": Class.Scene,
      "version": WideoDefVersion.V57,
      "width": 1920,
      "height": 1080,
      "hidden": false,
      "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
      "attributes": {
        "x": 960,
        "y": 540,
        "scaleX": 1,
        "scaleY": 1,
        "rotation": 0,
        "alpha": 1
      },
      "components": [
        {
          "id": "back-4",
          "class": Class.BackgroundComponent,
          "color": "0xff00ff",
        }
      ],
      "objects": [
        {
          "id": "scene-4-object-group-1",
          "class": Class.ObjectGroup,
          "startTime": 0,
          "endTime": 2000,
          "hidden": false,
          "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "x": 0,
            "y": 0,
            "scaleX": 1,
            "scaleY": 1,
            "rotation": 0,
            "alpha": 1
          },
          "components": [
            {
              "class": Class.AnimationComponent,
              "animation": {
                "keyFrames": [
                  {
                    "attributes": {
                      "rotation": 0,
                      "x": 0,
                      "y": 0,
                      "scaleX": 1,
                      "scaleY": 1,
                      "alpha": 1
                    },
                    "time": 0,
                    "id": "fe6b700f-e6ab-4b52-85bc-f29baf64b6ba"
                  },
                  {
                    "attributes": {
                      "rotation": 0,
                      "x": 0,
                      "y": 0,
                      "scaleX": 2,
                      "scaleY": 2,
                      "alpha": 0
                    },
                    "time": 2000,
                    "id": "1fe6b700f-e6ab-4b52-85bc-f29baf64b6ba"
                  }
                ]
              }
            }
          ],
          "objects": [
            {
              "id": "scene-4-object-group1-zlatan.jpg",
              "class": Class.ImageObject,
              "startTime": 0,
              "endTime": 2000,
              "hidden": false,
              "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
              "attributes": {
                "x": 0,
                "y": 0,
                "scaleX": 0.25,
                "scaleY": 0.25,
                "rotation": 0,
                "alpha": 1
              },
              "components": [
                {
                  "id": "scene-4-object-group1-zlatan.jpg",
                  "class": Class.ImageComponent,
                  "src": resourcesBaseUrl + "/img/defaults/zlatan.jpg",
                  "animated": false
                },
                {
                  "class": Class.AnimationComponent,
                  "animation": {
                    "keyFrames": [
                      {
                        "attributes": {
                          "rotation": 0,
                          "x": 0,
                          "y": 0,
                          "scaleX": 1,
                          "scaleY": 1,
                          "alpha": 1
                        },
                        "time": 0,
                        "id": "0e7917c2-65b5-416c-81e5-76d388ca5fde"
                      },
                      {
                        "attributes": {
                          "rotation": -3.14,
                          "x": 0,
                          "y": 0,
                          "scaleX": 1,
                          "scaleY": 1,
                          "alpha": 1
                        },
                        "time": 2000,
                        "id": "1e7917c2-65b5-416c-81e5-76d388ca5fde"
                      }
                    ]
                  }
                }
              ],
              "objects": []
            },
            {
              "id": "scene-4-object-group1-messizlatan.jpg",
              "class": Class.ImageObject,
              "startTime": 0,
              "endTime": 2000,
              "hidden": false,
              "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
              "attributes": {
                "x": -200,
                "y": 0,
                "scaleX": 0.25,
                "scaleY": 0.25,
                "rotation": 0,
                "alpha": 1
              },
              "components": [
                {
                  "id": "messizlatan",
                  "class": Class.ImageComponent,
                  "src": resourcesBaseUrl + "/img/defaults/messizlatan.jpg",
                  "animated": false
                },
                {
                  "class": Class.AnimationComponent,
                  "animation": {
                    "keyFrames": [
                      {
                        "attributes": {
                          "rotation": 0,
                          "x": 0,
                          "y": 0,
                          "scaleX": 1,
                          "scaleY": 1,
                          "alpha": 1
                        },
                        "time": 0,
                        "id": "0e7917c2-65b5-416c-81e5-76d388ca5fde1"
                      },
                      {
                        "attributes": {
                          "rotation": 0,
                          "x": 400,
                          "y": 0,
                          "scaleX": 1,
                          "scaleY": 1,
                          "alpha": 1
                        },
                        "time": 2000,
                        "id": "1e7917c2-65b5-416c-81e5-76d388ca5fde1"
                      }
                    ]
                  }
                }
              ],
              "objects": []
            }
          ]
        }
      ],
      "startTime": 12000,
      "endTime": 14000
    },
    {
      "id": "scene-5",
      "class": Class.Scene,
      "version": WideoDefVersion.V57,
      "width": 1920,
      "height": 1080,
      "hidden": false,
      "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
      "attributes": {
        "x": 960,
        "y": 540,
        "scaleX": 1,
        "scaleY": 1,
        "rotation": 0,
        "alpha": 1
      },
      "components": [
        {
          "id": "back-5",
          "class": Class.BackgroundComponent,
          "color": "0x123456",
        }
      ],
      "objects": [
        {
          "id": "scene-5-masked-group",
          "class": Class.MaskedObject,
          "startTime": 0,
          "endTime": 5000,
          "hidden": false,
          "locked": true, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
          "attributes": {
            "x": 0,
            "y": 0,
            "rotation": 0,
            "scaleX": 1,
            "scaleY": 1,
            "alpha": 1
          },
          "components": [],
          "objects": [
            {
              "id": "scene-5-mask",
              "class": Class.MaskObject,
              "startTime": 0,
              "endTime": 5000,
              "hidden": false,
              "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
              "type": MaskType.RoundedRect,
              "width": 400,
              "height": 400,
              "targetId": "scene-5-messizlatan",
              "attributes": {
                "x": -100,
                "y": 0,
                "rotation": 0,
                "scaleX": 1,
                "scaleY": 1,
                "alpha": 1
              },
              "components": [
                {
                  "class": Class.AnimationComponent,
                  "animation": {
                    "keyFrames": [
                      {
                        "attributes": {
                          "rotation": 0,
                          "x": 0,
                          "y": 0,
                          "scaleX": 1,
                          "scaleY": 1,
                          "alpha": 1
                        },
                        "time": 0,
                        "id": "0e7917c2-65b5-416c-81e5-76d388ca5fde2"
                      },
                      {
                        "attributes": {
                          "rotation": 0,
                          "x": 200,
                          "y": 0,
                          "scaleX": 1,
                          "scaleY": 1,
                          "alpha": 1
                        },
                        "time": 5000,
                        "id": "1e7917c2-65b5-416c-81e5-76d388ca5fde2"
                      }
                    ]
                  }
                },
                {
                  "class": Class.TransitionComponent,
                  "type": TransitionType.Intro,
                  "tween": Tween.PopIn,
                  "length": 1000
                },
              ],
              "objects": []
            },
            {
              "id": "scene-5-messizlatan",
              "class": Class.ImageObject,
              "startTime": 0,
              "endTime": 5000,
              "hidden": false,
              "locked": false, "scaleXInverted": false, "scaleYInverted": false, "loop": false,
              "maskId": "scene-5-mask",
              "attributes": {
                "x": 0,
                "y": 0,
                "rotation": 0,
                "scaleX": 2,
                "scaleY": 2,
                "alpha": 1
              },
              "components": [
                {
                  "id": "messizlatan.jpg",
                  "class": Class.ImageComponent,
                  "src": resourcesBaseUrl + "/img/defaults/messizlatan.jpg",
                  "animated": false
                },
                {
                  "class": Class.AnimationComponent,
                  "animation": {
                    "keyFrames": [
                      {
                        "attributes": {
                          "rotation": 0,
                          "x": 0,
                          "y": 0,
                          "scaleX": 1,
                          "scaleY": 1,
                          "alpha": 1
                        },
                        "time": 0,
                        "id": "0e7917c2-65b5-416c-81e5-76d388ca5fde3"
                      },
                      {
                        "attributes": {
                          "rotation": -3.14,
                          "x": 0,
                          "y": 0,
                          "scaleX": 1,
                          "scaleY": 1,
                          "alpha": 1
                        },
                        "time": 5000,
                        "id": "1e7917c2-65b5-416c-81e5-76d388ca5fde3"
                      }
                    ]
                  }
                }
              ],
              "objects": []
            }
          ]
        }
      ],
      "startTime": 14000,
      "endTime": 19000
    }
  ],
  "audios": [],
}
